import {gql} from "@apollo/client";

export const GET_JOB_SETTINGS = gql`
	query getJobSettings ($filter: JobSettingsFilterInput) {
		jobSettings (where: $filter) {
			nodes {
				id
				description
				settings
			}
		}
	}
`;
